import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { mapUpgradeDetails } from 'src/js/mapper/upgrade-details-mapper';
import { UpgradeDetailsResponse } from 'src/js/model/api/response/upgrade-details-response';
import { UpgradeDetails } from 'src/js/model/api/upgrade-details';
import { SettingsTabContent } from 'src/js/pages/settings/settings-tab-content';
import { mapCurrentVersionViewModel } from 'src/js/pages/settings/upgrade/current-version-view-model-mapper';
import { UpdateSoftware } from 'src/js/pages/settings/upgrade/update-software';

export const Upgrade: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [upgradeDetails, setUpgradeDetails] = useState<UpgradeDetails>();

  const fetchUpgradeState = () => {
    return apiClientWithoutHandler.genericController.get<UpgradeDetailsResponse>(APIPath.upgrade.get).then((res) => {
      return res;
    });
  };

  useEffect(() => {
    fetchUpgradeState().then((res) => res.ok && setUpgradeDetails(mapUpgradeDetails(res.data)));
  }, []);

  return (
    <SettingsTabContent name={t('settings.upgrade.title')}>
      <UpdateSoftware data={mapCurrentVersionViewModel(upgradeDetails)} />
    </SettingsTabContent>
  );
};
